import React from 'react'
import Form from '../../../Common/Form'
const Render = ({ onSignIn }) => {
    return (
        <Form submit={onSignIn}
            loading="<div class='d-flex align-items-center'><span class='mx-2'> درحال بررسی  </span> <span class='spinner-border spinner-border-sm' role='status'></span></div>">
            <div className='title'>
                <h1>ورود به پنل کاربری</h1>
            </div>
            <div className='input-group'>
                <div className='inputs'>
                    <label className='label' htmlFor='username'>نام کاربری</label>
                    <input className='input' type='text' name='username' />
                </div>
                <div className='inputs'>
                    <label className='label' htmlFor='password'>کلمه عبور</label>
                    <input className='input' type='password' name='password' />
                </div>
            </div>
            <div className='login'>
                <button type='submit' >ورود به پنل</button>
            </div>
        </Form>
    )
}

export default Render